
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightRainShowersPolartwilight as ObiLightningLightRainShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-rain-showers-polartwilight.js';
 
 
 

 
 export const ObiLightningLightRainShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-lightning-light-rain-showers-polartwilight',
   elementClass: ObiLightningLightRainShowersPolartwilightElement,
   events: {
     
   }
  });
 
 